var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.fields && _vm.canShow
    ? _c(
        "div",
        { staticClass: "vote-c", attrs: { "data-spm": "select" } },
        [
          !_vm.isStart
            ? _c("UnStart")
            : _c(
                "div",
                {
                  attrs: {
                    "data-spm-type": "resource",
                    "data-spm-content": "",
                  },
                },
                [
                  _vm.isText
                    ? _c("TextVote", {
                        attrs: { fields: _vm.fields, isFinish: _vm.isFinish },
                        on: { sendVote: _vm.handleSendVote },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isPicture
                    ? _c("PictureVote", {
                        attrs: { fields: _vm.fields, isFinish: _vm.isFinish },
                        on: { sendVote: _vm.handleSendVote },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showCancleModal
                    ? _c("CancleModal", {
                        attrs: { page: _vm.page },
                        on: { closeCancleModal: _vm.closeCancleModal },
                      })
                    : _vm._e(),
                ],
                1
              ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }